import { getFormattedDateString } from 'helpers';

export const getEventInfoWithDates = (event) => {
  const { EventName, dateStart, dateEnd, location } = event;
  const eventName = EventName ? EventName : '';
  const startDateString = getFormattedDateString(dateStart);
  const endDateString = getFormattedDateString(dateEnd);
  const dateRangeString =
    startDateString && endDateString
      ? `from ${startDateString} to ${endDateString}`
      : '';
  const loc = location ? `${location}` : '';
  const eventInfo = loc ? `${eventName} in ${loc}` : `${eventName}`;
  const eventInfoWithDates = dateRangeString
    ? `${eventInfo} ${dateRangeString}`
    : `${eventInfo}`;

  return eventInfoWithDates;
};
